module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: ['big-btn', _vm.mutableColor],
    style: (_vm.computedStyle),
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n  Purchase \n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52c08b8d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchaseButton.vue
// module id = 499
// module chunks = 1